import { route } from "@lernetz/ts-lib";
import { Gateway } from "@lernetz/ts-lib/src/Gateway";
// import {Image} from "@lernetz/ui-components/src/image/Image";
import {Image} from "../components/article-elements/image/Image";
import {Paragraph} from "../components/article-elements/paragraph/Paragraph";
import { Podcast } from "../components/article-elements/podcast/Podcast";
import {Title} from "../components/article-elements/title/Title";
import { WizardAnswer, WizardQuestion } from "../components/wizard/wizard.model";
import {GoodPracticeGateway} from "../good-practice/good-practice.gateway";
import {ColumnLayout} from "../pages/generic/article-elements/column-layout/column-layout.component";
import {Column} from "../pages/generic/article-elements/column-layout/column.component";
import {Contact} from "../pages/generic/article-elements/contact/contact.component";
import {ToolGateway} from "../tool/tool.gateway";
import {httpService, lookup} from "./api-service";

class WizardGateway extends Gateway {
    toolGateway: ToolGateway;
    goodPracticeGateway: GoodPracticeGateway;
    constructor() {
        super({});
        this.in.add(
            "App\\WizardQuestion",
            (dto: any) => new WizardQuestion(dto)
        );
        this.in.add(
            "App\\WizardAnswer",
            (dto: any) => new WizardAnswer(dto)
        );
        this.in.add( 'App\\Title', ( dto: any ) => new Title( dto ) );
        this.in.add( 'App\\Paragraph', ( dto: any ) => new Paragraph( dto ) );
        this.in.add( 'App\\Image', ( dto: any ) => new Image(dto)
                    // return new Image({ ...dto.image, route: 'asset', preset: 'original'}, )
                   );

        this.in.add( 'App\\ColumnLayout', ( dto: any ) => new ColumnLayout( dto ) );
        this.in.add( 'App\\Column', ( dto: any ) => new Column( dto ) );
        this.in.add( 'App\\Contact', ( dto: any ) => new Contact( dto ) );
        this.in.add( 'App\\Podcast', ( dto: any ) => new Podcast( dto ) );

        this.toolGateway = new ToolGateway( { in: this.in, out: this.out } );
        this.goodPracticeGateway = new GoodPracticeGateway( { in: this.in, out: this.out } );
    }

    async loadInitialWizardQuestion() {
        return route("api.wizard.start")
            .load()
            .then((res: { data: any }) => {
                return this.in.transform(res.data);
            });
    }

    async get(id: string) {
        return route("api.wizard.question", {id})
            .load()
            .then((res: { data: any }) => {
                return this.in.transform(res.data);
            });
    }

    async loadPage(slug) {
        const page = await route("api.page", {slug}).load();
        return this.in.transform(page);
    }

    async loadFilters() {
        return route("api.filter").load();
    }

    async loadTopics() {
        // return httpService.get(lookup("api.topics").url)

        return route("api.topics").load() as any;
    }

    async search(q) {
        const res = await route("api.search").send(JSON.stringify({q})) as any;
        return this.in.transform(res);
    }

    async loadGeneralInfos() {
        const res = await route("api.general").load() as any;
        return this.in.transform(res);
    }

}

interface WizardDto {
    id: string;
}

export const gateway = new WizardGateway();
